module.exports = {"event_expiry":"Event Expires "}